import { Injectable } from '@angular/core';
import { MyHeader } from '../../config/myHeader';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PageInformations } from '../generic-table/class/PageInformations';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'any'
})
export class GenericSearchService {

  header : MyHeader= new MyHeader();

  constructor(private http:HttpClient) { }

  public search(endpoint: string, query: string, page: number = 0, size: number = 10, orderBy: string): Observable<any>{

    return this.http.get<any>(`${environment.urlBackend}${endpoint}/search?query=${query}&page=${page}&size=${size}&orderBy=${orderBy}` );
  }

  public searchWithEndpointPersonnalized(endpoint: string, query: string, page: number = 0, size: number = 10, orderBy: string): Observable<any>{

    return this.http.get<any>(`${environment.urlBackend}${endpoint}?query=${query}&page=${page}&size=${size}&orderBy=${orderBy}` );
  }

  public updatePageInformations(pageInformations: PageInformations, page: any): PageInformations {
    pageInformations.pageIndex = page.content.length;
    pageInformations.pageIndex = page.number;
    pageInformations.pageSize = page.size;
    pageInformations.totalElements = page.totalElements;
    pageInformations.totalPages = page.totalPages;
    return pageInformations;
  }}
